/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./segment.defs.js";
export { main as default } from "./segment.defs.js";
